<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kod</label>
            <input type="text" class="form-control" v-model="value.Code" placeholder="Kod" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İsim</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="İsim" />
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
}
</script>

<style>

</style>